import BaseService from "./geral/BaseService";
import {urlApi} from "../config/Constantes";

const base = "Acesso";
const baseUsuario = "CadastrarUsuario";

export default class ControleAcessoService extends BaseService {
    constructor() {
        super();
    }

    listarPais = () => {
        return this.httpGet(`${baseUsuario}/ListarPais`, false);
    };

    listarUF = () => {
        return this.httpGet(`${baseUsuario}/ListarUf`, false);
    };

    listarPerfilUsuario = () => {
        return this.httpGet(`${base}/listar-perfil-usuario`, false);
    };
    
    listarPerfil = () => {
        return this.httpGet(`${base}/listar-perfil`, false);
    };

    salvarUsuario = (usuario) => {
        return this.httpPost(`${base}/salvar-usuario`, usuario, false);
    };
    
    salvarPreCadastroUsuario = (usuario) => {
        return this.httpPost(`${baseUsuario}/SalvarPreCadastroUsuario`, usuario, false);
    };
    
    VerificarSeExisteCpfCnpj = (cpfCnpj) => {
        return this.httpGet(`${baseUsuario}/VerificarSeExisteCpfCnpj?cpfCnpj=${cpfCnpj}`, false);
    };

    downloadTermo = () => {
        return `${urlApi}/CadastrarUsuario/DownloadTermo`;
    };

    sample = {
        Pessoa: {
            Nome: "",
            CPF: "",
            DataNascimento: "",
            Endereco: "",
            Cep: "",
            Ddd: 0,
            Telefone: 0,
            Ramal:0,
            Email: ""
          },
        Empresa: {
            RepresentanteBrasil: "N",
            Cnpj: "",
            Nome: "",
            Endereco: "",
            Pais: "",
            Estado: "",
            Cidade: "",
            Cep: "",
            Ddd: 0,
            Telefone: 0,
            Email: "",
            Contato: "",
            EmailOpcional: "",
            Parceiros: [],
            Perfis: []
        }
    };
}


// WEBPACK FOOTER //
// ./src/services/ControleAcessoService.js